import { ACTION_GET_GCASH_ACCOUNT_LISTS, ACTION_GET_GCASH_ACCOUNT_LISTS_ERROR, ACTION_GET_GCASH_ACCOUNT_LISTS_SUCCESS } from "."
import * as api from "../../../api"
import * as authActions from "../../auth/actions";

export const getGcashAccountListsRequest = (access_token, vip, ref, appInfo, url) => ({
    type: ACTION_GET_GCASH_ACCOUNT_LISTS,
    payload: {
        access_token,
        vip,
        ref,
        appInfo,
        url
    }
})

export const getGcashAccountListsSuccess = data => ({
    type: ACTION_GET_GCASH_ACCOUNT_LISTS_SUCCESS,
    payload: {
        data
    }
})


export const getGcashAccountListsError = (msg) => ({
    type: ACTION_GET_GCASH_ACCOUNT_LISTS_ERROR,
    payload: {
        msg
    }
})

export const getGcashAccountLists = (access_token, vip, ref, appInfo, url) => {
    return dispatch => {
        dispatch(getGcashAccountListsRequest(access_token, vip, ref, appInfo, url))
        api.getGcashAccountLists(access_token, vip, ref, appInfo, url)
            .then(({ data }) => {
                if (data.result.code !== 0) {
                    dispatch(getGcashAccountListsError("error"));
                    return
                }

                const {accounts} = data
                dispatch(getGcashAccountListsSuccess(accounts));
            }).catch((err) => {

                console.log(err)

                if (err.response) {
                    if (err.response.status === 401) {
                        dispatch(authActions.logout())
                        return
                    }
                }

                dispatch(getGcashAccountListsError("system error"))
            });
    }
}